import { useCallback } from 'react';
import type { FC } from 'react';
import SettingsItem from '../SettingsItem';
import ToggleSwitch from 'shared/components/ToggleSwitch';
import { useSeasonalBrandingSettings } from 'store/featureFlags/featureFlagsStore';
import Image from '../../../../../shared/components/Image';

export const SeasonalBrandingSettingsItem: FC = () => {
  const { hasBranding, enabled, setEnabled } = useSeasonalBrandingSettings();

  const handleToggleChange = useCallback((checked: boolean) => {
    setEnabled(checked);
  }, [setEnabled]);

  if (!hasBranding) return null;

  return (
    <SettingsItem
      labelKey="seasonal_branding_tab.seasonal_branding"
      descriptionKey="seasonal_branding_tab.seasonal_branding_description"
      icon={
        <Image src={enabled ? '/icons/BrandingOn' : '/icons/BrandingOff'} manualAffix=".svg" alt="seasonalBranding" />
      }
    >
      <ToggleSwitch checked={enabled} onChange={handleToggleChange} />
    </SettingsItem>
  );
};
